import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useAppConfig } from '../../../hooks/use-app-config';
import Lottie from 'lottie-react';
import newLoader from '../../../assets/newLoader.json';

export function PendingMessage() {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const { featureFlags } = useAppConfig();

  const isTextHidden = featureFlags?.checkout_processing_text_hidden;

  return (
    <div className="success-wrapper">
      <section
        className="success"
        dir="auto"
        style={{
          width: 'fit-content',
          textAlign: 'center',
        }}
      >
        {!isTextHidden && (
          <>
            <motion.h1
              style={{
                padding: 0,
                margin: 0,
              }}
            >
              {t('processing')}
            </motion.h1>

            <motion.h4
              style={{
                padding: 0,
                margin: 0,
              }}
            >
              {t('thisWillOnlyTakeAFewMoments')}
            </motion.h4>
          </>
        )}
        <Lottie animationData={newLoader} className="button-loader" />
      </section>
    </div>
  );
}
